if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    
    const { 
        InspectorControls,
        MediaUpload,
        InnerBlocks
    } = window.wp.editor;
    
    const { 
        PanelBody, 
        IconButton, 
        Button,
    } = window.wp.components;

    registerBlockType('custom-gutenberg/background-image', {
        // built-in attributes
        title: 'Background image',
        description: 'Background image',
        icon: '',
        category: 'custom-cards',
        example: {},

        // custom attributes
        attributes: {
            link: {
                type: 'string',
                default: '',
            },
            image: {
                type: 'string',
                default: ''
            }, 
            alt: {
                type: 'string',
                default: ''
            },
        },

        // built-in functions
        edit({ attributes, setAttributes }) {

            const {
                image,
                alt,
            } = attributes;

            // custom functions

            function onSelectImage(image) {
                setAttributes({image: image.sizes.full.url});
            }

            function onRemoveImage() {
                setAttributes({ image: '' });
                setAttributes({ alt: '' });
            }

            function onTitleChange(title) {
                setAttributes({title: title});
            }

            return ([
                <InspectorControls style={ { marginBottom: '40px' } }>
                    <PanelBody title={ 'Settings' }>
                        <MediaUpload 
                            onSelect={ onSelectImage }
                            type="image"
                            value={ image } 
                            render={ ( { open } ) => (
                                <div>
                                    { image && (
                                        <div>
                                            <figure style={{ margin: 0 }}>
                                                <img src={ image } style={{ maxWidth: '200px', maxHeight: '150px', objectFit: 'cover' }} />
                                            </figure>
                                            <Button
                                                onClick={ onRemoveImage }
                                                className="button"
                                                style={{ marginTop: '10px', marginBottom: '10px' }}>
                                                Remove
                                            </Button>
                                        </div>
                                    )}
                                    <IconButton
                                        onClick={ open }
                                        icon="upload"
                                        classNames="editor-media-placeholder__button is-button is-default is-large">
                                        { image ? 'Replace Background Image' : 'Select Background Image' }
                                    </IconButton>
                                </div>
                            ) } />
                    </PanelBody>
                </InspectorControls>
                ,

                <div class="cover-image background-image-section" style={ image ? { backgroundImage: `url(${image})` } : undefined } >
                    <InnerBlocks />
                </div>
                
            ]
            );
        },

        save({ attributes }) {

            const {
                image,
            } = attributes;

            return (
                <div className="lozad cover-image background-image-section" data-background-image={ image }>
                    <InnerBlocks.Content />
                </div>
            );
        },
    });
}